import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { SEGMENT_BY_SLUG } from "@/lib/segments";
import SegmentRoute from "@/pages/SegmentRoute";

export const Route = createFileRoute("/agente-ia-seguro-auto")({
  head: () => buildHead({
    title: SEGMENT_BY_SLUG["agente-ia-seguro-auto"]!.metaTitle,
    description: SEGMENT_BY_SLUG["agente-ia-seguro-auto"]!.metaDescription,
    path: "/agente-ia-seguro-auto",
  }),
  component: () => <SegmentRoute slug="agente-ia-seguro-auto" />,
});
